import React, {useContext} from 'react'
import {Form, Input} from "antd"
import {RecipeConText} from "../../../../../context/RecipeContext";


const RecipeFilePath = () => {
    const {recipeAbstract} = useContext(RecipeConText)
    const [abstractState, setAbstractState] = recipeAbstract

    const handlePathChange = (event) => {
        let mockAbstract = Object.assign({}, abstractState)
        mockAbstract.imageUrl = event.target.value
        setAbstractState(mockAbstract)
    }

    return(
        <React.Fragment>
            <Form.Item
                className={'font-bold'}
                name={'recipeFilePath'}
                label={'Dosya Yolu'}
                onChange={handlePathChange}
            >
                <Input />
            </Form.Item>
        </React.Fragment>
    )
}
export default RecipeFilePath